import { QueryClient, QueryClientProvider } from "@tanstack/preact-query";
import { useGSAP } from "@gsap/react";
import { Flip } from "gsap/Flip";
import { render } from "preact";
import { gsap } from "gsap";

import App from "./App";

import "./globals.less";
import "./VKAPI.js";

gsap.registerPlugin(Flip, useGSAP);

const root = document.getElementById("root");
if (root) {
    const queryClient = new QueryClient();

    render(
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>,
        root,
    );
}
